import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
export const API = `${BACKEND_URL}/api`;

// All auth lives in HTTP-only cookies (set by the backend on login).
// No tokens are stored client-side. withCredentials ensures cookies are
// sent on every cross-origin request.
export const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' },
});

// Kept as a no-op for backwards-compat with any callers that still invoke it.
// (Auth tokens are no longer stored in localStorage.)
export function setBearer(_token) {
  // Intentionally no-op. HTTP-only cookies are the source of truth.
}

export function getTrySessionId() {
  let id = localStorage.getItem('revcore_try_session');
  if (!id) {
    id = 'try_' + Math.random().toString(36).slice(2) + Date.now().toString(36);
    localStorage.setItem('revcore_try_session', id);
  }
  return id;
}
